import {AfterViewInit, Component, Inject} from '@angular/core';
import {CurrencyPipe} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";

@Component({
  selector: 'app-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrl: './yes-no-modal.component.scss'
})
export class YesNoModalComponent implements AfterViewInit {

  identifier = '';
  text= '';

  constructor(
    public dialogRef: MatDialogRef<YesNoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.text = data?.text || '';
    this.identifier = data?.identifier || data;
  }

  ngAfterViewInit() {
  }

}
